import { Injectable } from '@angular/core';
import { CookieService as CS } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor(private cookieService: CS) { }

  /******** Below are the methods for handling browser cookies ***********/

  public GetCookieValue(cookie: string): any {
    if (!this.cookieService.check(cookie)) { return; }
    return this.cookieService.get(cookie);
  }

  public SetCookieValue(cookie: string, value: any): void {
    this.cookieService.set(cookie, value, 2);
  }

  public RemoveCookieValue(cookie: string): void {
    if (!this.cookieService.check(cookie)) { return; }
    this.cookieService.delete(cookie);
  }

  public RemoveAllCookies(): void {
    this.cookieService.deleteAll();
  }

}
